import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'searchbutton',
  templateUrl: './searchbutton.component.html',
})
export class SearchButtonComponent {

  @Output() searchClick = new EventEmitter<void>();
  @Output() cancelClick = new EventEmitter<void>();

  onSearch(): void {
    this.searchClick.emit();
  }

  onCancel(): void {
    this.cancelClick.emit();
  }
}